import React from 'react';

export function PageHeader({ title, subtitle, actions, testId }) {
    return (
        <div className="mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3" data-testid={testId || 'page-header'}>
            <div>
                <h1 className="text-2xl sm:text-3xl font-display tracking-tight text-slate-900" data-testid={`${testId || 'page'}-title`}>{title}</h1>
                {subtitle && <p className="mt-1 text-sm sm:text-base text-slate-600 font-body">{subtitle}</p>}
            </div>
            {actions && <div className="flex items-center gap-2">{actions}</div>}
        </div>
    );
}
